import { render, staticRenderFns } from "./DialogUserDetails.vue?vue&type=template&id=5a7549e4&scoped=true"
import script from "./DialogUserDetails.vue?vue&type=script&lang=js"
export * from "./DialogUserDetails.vue?vue&type=script&lang=js"
import style0 from "./DialogUserDetails.vue?vue&type=style&index=0&id=5a7549e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7549e4",
  null
  
)

export default component.exports